import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { WidgetSession } from '@wix/wix-chatbot-common/browser';
import { v4 as uuid } from 'uuid';

import { getWidgetRuntimeData } from '../thunks/widgetRuntime.thunk';
import { IWidgetSessionState } from './types';

const initialState: IWidgetSessionState = {
  // TODO: should we move this to common channel(to have it in each event)
  sessionTabId: uuid(),
  isSessionExpired: false,
};

type UrlActions = {
  readonly addedUrl?: string;
  readonly replacedUrl?: string;
  readonly removeLast?: boolean;
};

export const widgetSessionSlice = createSlice({
  name: 'widgetSession',
  initialState,
  reducers: {
    setWidgetSession: (state, action: PayloadAction<WidgetSession>) => {
      state.session = action.payload;
      state.isSessionExpired = false;
    },
    sessionExpired: (state) => {
      state.session = undefined;
      state.isSessionExpired = true;
    },
    urlChanged: (state, action: PayloadAction<UrlActions>) => {
      state.addedUrl = action.payload.addedUrl;
      state.replacedUrl = action.payload.replacedUrl;
      state.removeLast = action.payload.removeLast;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWidgetRuntimeData.fulfilled, (state, action) => {
      state.session = action.payload.widgetSession;
    });
  },
});
export const widgetSessionInitialState = widgetSessionSlice.getInitialState();
export const widgetSessionActions = widgetSessionSlice.actions;
